/* lua.js generated code 0.3.0 */
var PaymentGuideManager = require("activity/IosPaymentGuide/PaymentGuideManager")
var GameProxyH5 = xClass("GameProxyH5", GameProxy)
var decisionStoragePath = "/smspaydecision.ds"
var SnsProxy = require("clover/sns/SnsProxy")
GameProxyH5.prototype.loadFCNew = function (defaultTag, defaultUrl) {
    // TODO:
}
GameProxyH5.prototype.restart = function () {
}
GameProxyH5.prototype.setShareType = function (shareType) {
    var self = this
    ShareProxy.setShareTypeH5(shareType)
}

GameProxyH5.prototype.getAuthConfig = function () {
    var self = this
    return table()
}

GameProxyH5.prototype.getIsQQAvailable = function () {
    var self = this
    return true
}
GameProxyH5.prototype.getFCCode = function () {
}

GameProxyH5.prototype.checkGoodsBanned = function (goodsId) {
}
GameProxyH5.prototype.isNetworkReachable = function () {
    return true
}
GameProxyH5.prototype.loadFC = function () {
}
GameProxyH5.prototype.convertToInvokeCallback = function (callback) {
}
GameProxyH5.prototype.init = function () {
    var self = this
    GameProxy.prototype.init.call(self)
    // var PlatformHelper = luajava.bindClass("com.happyelements.android.platform.PlatformHelper")
    // self.wechatAppId = PlatformHelper.getWXAppId()
    // self.wechatPayAppId = PlatformHelper.getWXPayAppId()
    // var [defaultDecisionFunc, defaultMd5] = unpack(require("clover/payment/AndroidSMSPaymentDecision"))
    // cc.log("GameProxyH5:init", defaultDecisionFunc, defaultMd5)
    // self.defaultDecisionFunc = defaultDecisionFunc
    // self.updateSMSPaymentDecisionFunction(defaultDecisionFunc, defaultMd5)

    if (META.user.platform == XcloverPlatform.qq ||
        META.user.platform == XcloverPlatform.weixin
        ) {
        self.setShareType(ShareType.QQ)
        self.shareType = ShareType.QQ
    } else if (META.user.platform == XcloverPlatform.wechatgame) {
        self.setShareType(ShareType.Wechatgame)
        self.shareType = ShareType.Wechatgame
    }else {
        self.setShareType(ShareType.QQ)
        self.shareType = ShareType.QQ
    }
    self.checkDevice()
}
GameProxyH5.prototype.buildCallback = function (callback) {
    return callback
}
GameProxyH5.prototype.isWeChatInstalled = function () {
    return true
}
GameProxyH5.prototype.isQQInstalled = function () {
    return true
}
GameProxyH5.prototype.initAuthorizeConfig = function (config) {
    var self = this
    TODO("initAuthorizeConfig")
}

GameProxyH5.prototype.initShareConfig = function (config) {
    var self = this
    TODO("initShareConfig")
    cc.log(table.tostring(config))
}
GameProxyH5.prototype.hasCamaraPermission = function () {
    var self = this
    return true
}
GameProxyH5.prototype.openSettings = function (setting) {
}
GameProxyH5.prototype.openUrl = function (url, onSuccess, onFailed, onCancel) {
    SnsProxy.getInstance().openUrl(0, url, 1, false, onSuccess, onFailed, onCancel);
}
GameProxyH5.prototype.openFC = function(defaultTab, onSuccess, onFailed, onCancel) {
    var host = 'https://fansclub.happyelements.com/fans/faq.php';
    SnsProxy.getInstance().openUrl(defaultTab, host, 1, true, onSuccess, onFailed, onCancel);
}
GameProxyH5.prototype.openForum = function(defaultTab, onSuccess, onFailed, onCancel) {

    if (window.switchs.forumSwitch === ForumSwitch.CLOSE) {
        onFailed && onFailed()
        return
    }else {
        var host = FotumURL[window.switchs.forumSwitch]
        host = host || 'https://fansclub.happyelements.com/fans/ff.php';
        SnsProxy.getInstance().openUrl(defaultTab, host, 1, false, onSuccess, onFailed, onCancel);    
    }   
}
function reInitUnicomAndNotUsed() {
    TODO("reInitUnicomAndNotUsed() 联通放量打开")
}
GameProxyH5.prototype.lazyInit = function () {
    var self = this
    cc.log("GameProxyH5:lazyInit()")
}
GameProxyH5.prototype.hasCamaraPermission = function () {
    var self = this
    return true
}
GameProxyH5.prototype.getCamaraPermissionstatus = function () {
    var self = this
    return PrivilegeStatus.kOk
}
GameProxyH5.prototype.refresh = function () {    
    SnsProxy.getInstance().refresh()
}
GameProxyH5.prototype.getLoginInfo = function (callback, sessionCallback, isPreGet, forceNewCode) {
    SnsProxy.getInstance().getOpenKey(callback, sessionCallback, isPreGet, forceNewCode)
}
GameProxyH5.prototype.updateNameHeadAfterLogin = function () {
    SnsProxy.getInstance().updateNameHeadAfterLogin()
}
GameProxyH5.prototype.getDebugInfo = function (callback) {
    SnsProxy.getInstance().getDebugInfo(callback)
}
GameProxyH5.prototype.getNotificationPermissionStatus = function () {
    var self = this
    return PrivilegeStatus.kOk
}
GameProxyH5.prototype.phoneCall = function (phoneNumer) {
    // var self = this
    // phoneNumer = phoneNumer || ""
    // phoneNumer = string.trim(phoneNumer)
    // if ($len(phoneNumer) > 0) {
    //     luajava.bindClass("com.happyelements.android.ApplicationHelper").phoneCall(phoneNumer)
    // }
}
var _is_android_low_device = -1
GameProxyH5.prototype.checkDevice = function () {
    if (__use_small_res && __use_low_effect) {
        _is_android_low_device = 0
    }else if (__use_small_res && !__use_low_effect) {
        _is_android_low_device = 1
    }else if (!__use_small_res && __use_low_effect) {
        _is_android_low_device = 1
    }else if (!__use_small_res && !__use_low_effect) {
        _is_android_low_device = 2
    }
    // var self = this
    // if (_is_android_low_device === -1) {
    //     var result = false
    //     function docheck() {
    //         var physicalMemory = luajava.bindClass("com.happyelements.AndroidClover.share.DisplayUtil").getSysMemory()
    //         physicalMemory = physicalMemory / (1024 * 1024)
    //         cc.log(string.format("physicalMemory:%f ", physicalMemory))
    //         var frame = cc.Director.getInstance().getOpenGLView().getFrameSize()
    //         if (physicalMemory < 600 || frame.width < 400) {
    //             _is_android_low_device = 0
    //         } else if (physicalMemory < 1200 || frame.width < 500) {
    //             _is_android_low_device = 1
    //         } else {
    //             _is_android_low_device = 2
    //         }
    //         //曾经用int存的导致越界
    //         if (physicalMemory < 0) {
    //             _is_android_low_device = 2
    //         }
    //     }
    //     function onCheckError() {
    //         var __VA_ARG = $slice(arguments, 0)
    //         _is_android_low_device = 2
    //     }
    //     xpcall(docheck, onCheckError)
    // }
}
GameProxyH5.prototype.isLowDevice = function () {
    var self = this
    return _is_android_low_device <= 1
}
GameProxyH5.prototype.isLowestDevice = function () {
    var self = this
    return _is_android_low_device < 1
}

GameProxyH5.prototype.buyProduct = function (data, onSuccess, onFail, onCancel, needMask) {
    var self = this
    let loadId = null
    function removeAnim() {
        if (loadId) {
            LoadingPanelLogic.getInstance().remove(loadId)
            loadId = null
        }
    }
    function success(payParam) {
        cc.log("[Pay]","GameProxyH5 buyProduct success payParam",payParam,data);
        // if (data ){
        //     let value = 0
        //     if (data.score) data.score * 10
        //     if (data.money) data.money * 100
        //     DnSdkTool.getInstance().onPurchase(value)
        // }
        removeAnim()
        window.logCenter
        global.logCenter
        onSuccess && onSuccess(payParam)
    }
    function fail(evt) {
        cc.log("[Pay]","GameProxyH5 buyProduct fail evt",evt);
        removeAnim()
        onFail && onFail(evt)
        // cc.log("[Pay]","GameProxyH5 buyProduct fail logCenter",window.logCenter);
        if (evt && (evt.type == 1 || evt.type == 2) && window.logCenter) {
            let code = evt.code || "";
            let e_data = evt.data || "";
            let msg = evt.msg || "";
            let errMsg = `code=${code} e_data=${e_data} msg=${msg}`;
            let uid = data.uid || "";
            let itemId = data.itemId || "";
            cc.log("[Pay]","GameProxyH5 buyProduct fail data errMsg",data,errMsg);

            logCenter.error(new Error(`uid=${uid} itemId=${itemId} pay failed! errMsg = ${errMsg} `), 'PayError')
        }
    }
    function cancel() {
        removeAnim()
        onCancel && onCancel()
    }
    if (needMask) {
        loadId = LoadingPanelLogic.getInstance().add(null, cancel)
    }
    // 记录支付时设备
    if (data.ext){
        data.ext.pay_equip = self.getPayEquip()
    }else{
        data.ext ={
            pay_equip : self.getPayEquip()
        }
    }
    console.log("[Pay]","GameProxyH5 buyProduct", JSON.stringify(data));
    require("clover/utils/H5PaymentProxy").getInstance().buy(data, success, fail, cancel)
}
GameProxyH5.prototype.payStatusCheck = function (success, fail) {
    let proxy = require("clover/utils/H5PaymentProxy").getInstance()
    if (proxy.payStatusCheck){
        proxy.payStatusCheck(success, fail)
    }
}

GameProxyH5.prototype.getNetworkType = function (callback) {
    SnsProxy.getInstance().getNetworkType(callback);
}
GameProxyH5.prototype.getGiftId = function () {
    return parseInt(getParameterByName('GIFT'), 10)
}
GameProxyH5.prototype.isFromShortcut = function (sceneValues) {
    return SnsProxy.getInstance().isFromShortcut(sceneValues)
}
GameProxyH5.prototype.isFromCover = function () {
    let via = getParameterByName("via")
    return (via ==="H5.COVER")
}
GameProxyH5.prototype.addShortcut = function (success, fail, cancel) {
    function callback(e) {
        if (!e.detail.hidden) {
            document.removeEventListener("cloverVisibilityChange", callback)
            success()
        }
    }
    let isQQIOS = SnsProxy.getInstance().isQQIOS()
    if (isQQIOS) {
        document.addEventListener("cloverVisibilityChange", callback)
    }
    SnsProxy.getInstance().addShortcut(success, fail, cancel)
}
/**
 * 玩吧游戏内调用消息接口向好友发送消息
 * @param data      object
 *        frd       string	好友uid列表，用“,”分隔 
 *        msgtype	int	    消息类型，1-pk消息，2-送心消息，3-自定义消息
 *        content	string	自定义消息内容
 */
GameProxyH5.prototype.sendGameBarMsg = function (data, onSuccess, onFail, onCancel) {
    var frd = data.frd;
    var msgtype = data.msgtype || 3;
    var content = data.content;
    SnsProxy.getInstance().sendGameBarMsg(frd, msgtype, content, onSuccess, onFail, onCancel);
}
/**
 * 玩吧游戏内领取礼包
 * @param giftID      int   礼包ID, 901-907
 *        
 */
GameProxyH5.prototype.getWanbaGiftRewards = function (giftID, onSuccess, onFail, onCancel) {
    SnsProxy.getInstance().getWanbaGiftRewards(giftID, onSuccess, onFail, onCancel);
}
/**
 * 游戏注册数据上报 注册在index处理，登录在此处理
 */
GameProxyH5.prototype.reportLogin = function() {
    SnsProxy.getInstance().reportLogin();
}
/**
 * 获取分享链接
 * @param srcapp      string   来源app, 注册在window.META.user.app
 */
GameProxyH5.prototype.getShareLink = function(srcapp) {
    return SnsProxy.getInstance().getShareLink(srcapp);
}
GameProxyH5.prototype.getShareLinkStr = function(data) {
    return SnsProxy.getInstance().getShareLinkStr(data);
}
/**
 * 关闭右滑
 */
GameProxyH5.prototype.banSwipeBack = function() {
    return SnsProxy.getInstance().banSwipeBack();
}
/**
 * 发送陌生人消息，以本人名义给陌生人赠送礼物
 */
GameProxyH5.prototype.sendGift2Stranger = function(data) {
    var msgtype = data.msgtype || 3;
    var content = data.content;
    var src = data.src;
    return SnsProxy.getInstance().sendGift2Stranger(msgtype, content, src);
}
// TODO: 封装到GameProxy
GameProxyH5.prototype.getItemIDByKey = function (key) {
    let pf = META.user.serverid || 0
    let itemid = GOOD_ITEMS[PLATFORM_INDEX[pf]][key] || 0
    return itemid
}
GameProxyH5.prototype.getItemIDById = function (productId) {
    let productMeta = MetaManager.getInstance().getProductMetaByID(productId)
    let key = productMeta["itemKey"] || "cash"
    let pf = META.user.serverid || 0
    let itemid = GOOD_ITEMS[PLATFORM_INDEX[pf]][key] || 0
    return itemid
}
GameProxyH5.prototype.popBack = function() {
    return SnsProxy.getInstance().popBack()
}
GameProxyH5.prototype.onLoadingComplete = function() {
    return SnsProxy.getInstance().onLoadingComplete()
}
GameProxyH5.prototype.getPayEquip = function() {
    // return SnsProxy.getInstance().onLoadingComplete()
    if (PaymentGuideManager.getInstance().getFromHandoff()){
        return "ios_to_pc"
    }else if (window.mini && mini.getPlatform() == MiniPlatform.wechatGame && mini.getSystemInfoSync().platform == "windows"){
        return "pc"
    }else if (!isPlatformIOS()){
        return "android_mobile"
    }else if (UserManager.getInstance().canIosToMiniPay()){
        return UserManager.getInstance().getIosPayType() == "mini" ? "ios_h5" : "ios_h5_custom"
    }
    return "UnKnow"
}

// 检查是否需要去请求订阅
GameProxyH5.prototype.checkNeedRequestSubscribeSystemMessage = function(MSG_TYPE, callback) {
    SnsProxy.getInstance().checkNeedRequestSubscribeSystemMessage(MSG_TYPE, callback)
}

// 尝试订阅系统消息，微信用订阅更新消息
GameProxyH5.prototype.tryRequestSubscribeSystemMessage = function(MSG_TYPE, callback) {
    SnsProxy.getInstance().tryRequestSubscribeSystemMessage(MSG_TYPE, callback)
}

module.exports = GameProxyH5
